import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { casesReducer } from './casesReducer';
import { clientsReducer } from './clientsReducer';
import { userReducer } from './userReducer';
import { clearClientToken } from '../../client/token';

const appReducer = combineReducers({
    routing: routerReducer,
    cases: casesReducer,
    clients: clientsReducer,
    user: userReducer,
    toastr: toastrReducer,
});

const rootReducer = (state, action) => {
    if (action.type === 'USER_LOG_OUT') {
        state = undefined;
        clearClientToken();
    }

    return appReducer(state, action);
}

export default rootReducer;
